export default __webpack_public_path__ + "static/header-iconic-link-company-link-icon1.url-a307fe9c137a2bc806a4b8f719491eaf.svg";